module.exports = __webpack_public_path__ + "static/pinterest-543b164ffe8062dcea432d548a2bc1f1.svg";